import { keys, camelCase, join, inRange } from "lodash";
import { PHONE_MAX_LENGTH, PHONE_MIN_LENGTH } from "consts";

export const humanReadableList = list =>
  list?.length > 1
    ? join(list.slice(0, -1), ", ") + " and " + list.slice(-1)
    : list[0];

export const isEmailValid = email => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};

export const isValidName = name => {
  return /[^a-zA-Z|^\s]/gi.exec(name) !== null;
};

export const isStringNumeric = text => {
  return /^\d*$/.test(text);
};

export const isCellPhonenValid = contactNumber =>
  inRange(contactNumber.length, PHONE_MIN_LENGTH, PHONE_MAX_LENGTH);

export const stub = () => {};

export const pickThemeKey = key => props => props.theme["$" + key];

export const pickSizeKey = key => props => props.theme["$" + key + "_size"];

export const pickStyleKey = key => props => props.theme["$" + key + "_style"];

export const maxWidth = w => "max-width:" + w;

export const toCamelCase = obj =>
  keys(obj).reduce((o, k) => {
    o[camelCase(k)] = Array.isArray(obj[k])
      ? obj[k].map(v => toCamelCase(v))
      : typeof obj[k] === "object" && obj[k] !== null
      ? toCamelCase(obj[k])
      : obj[k];
    return o;
  }, {});

export const flexStart = () => props => (props.$RTL ? "right" : "left");

export const flexEnd = () => props => (props.$RTL ? "left" : "right");

export const flexRow = () => props => (props.$RTL ? "row-reverse" : "row");
